import { Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer"; // Update the path if needed
import MobileCallButton from "../helpers/MobileCallButton"; // Add this import (adjust path as needed)

export default function MainLayout() {
  return (
    <div className="relative max-lg:pb-[74px]">
      <Header />

      <main className="min-h-screen">
        <Outlet />
      </main>

      <Footer />

      {/* The fixed mobile button renders here */}
      <MobileCallButton />
    </div>
  );
}
